import React from 'react';
import { Fab, Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { Flare } from '@mui/icons-material';

interface ConfettiDebugFabProps {
  onClick: () => void;
}

const ConfettiDebugFab: React.FC<ConfettiDebugFabProps> = ({ onClick }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Tooltip title="Test Completed Listing Confetti" placement="left">
      <Fab
        color="secondary"
        size="medium"
        sx={{
          position: 'fixed',
          bottom: isMobile ? 80 : 30, // Higher than create debug FAB
          right: 80,
          zIndex: 900,
          bgcolor: 'secondary.main',
          '&:hover': {
            bgcolor: 'secondary.dark',
          },
        }}
        onClick={onClick}
        data-testid="confetti-debug-fab"
      >
        <Flare />
      </Fab>
    </Tooltip>
  );
};

export default React.memo(ConfettiDebugFab);
